import { useState, useEffect, FC } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import { useFormikContext } from "formik";
import usePrompt from "../../hooks/usePrompt";
import useLocales from "../../hooks/useLocales";

interface IStepButton {
  isSubmitting: boolean;
  isLastStep: boolean;
}

const StepButton: FC<IStepButton> = (props) => {
  const { translate } = useLocales();
  const formik: any = useFormikContext();
  let [isPrompt, setPrompt] = useState<boolean>(formik.dirty);

  usePrompt(translate("actions.are_you_sure_leave"), isPrompt);

  useEffect(() => {
    setPrompt(formik.dirty);
    if (props.isSubmitting) setPrompt(false);
  }, [formik.dirty, props.isSubmitting]);

  return (
    <LoadingButton
      loading={props.isSubmitting}
      className="btn btn-default"
      type="submit"
      disabled={props.isSubmitting}
      color="primary"
      style={{ minWidth: "200px", marginRight: "24px" }}
    >
      {props.isSubmitting
        ? translate("actions.submitting")
        : props.isLastStep
        ? translate("actions.save")
        : translate("actions.next")}
    </LoadingButton>
  );
};

export default StepButton;
